import React, { Component } from 'react';

import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import LeadsListContainer from '../LeadsList/LeadsListContainer';


class LeadsListCallbacks extends Component{
  render() {

    const {data: {loading, leads_callbacks, refetch}, app_data, filter_data} = this.props;

    if(loading) {
      return (<div>Загрузка</div>);
    }

    return (

      <div>
        <div className="leads_list__count">
          <span className="leads_list__count__label">Количество:</span>
          <span className="leads_list__count__number"> {leads_callbacks.length} </span>
        </div>

        <LeadsListContainer leads={leads_callbacks} app_data={app_data} refetch={refetch} with_client={true}/>
      </div>

    );
  }
}


export default compose(

  graphql(gql`query leads_callbacks{
    leads_callbacks{
      id,
      remonline_data,
      remonline_id,
      act_number,
      device_type_id,
      problem_type_id,
      status_id,
      model,
      comment,
      created_at
      client {
        id,
        name,
        phone
      }
    }
  }`, {
    options: () => {

      return {
      }

    }
  }),


)(LeadsListCallbacks);